import React, { useState } from 'react';
import MicroinverterForm from './MicroinverterForm';
import HGStepper from './HGStepper';
import ValidateDevices from './ValidateDevices';
import { steps } from './steps';
import { useNavigate } from 'react-router-dom';
import HGSuccessCard from 'components/HGSuccessCard';
import { useDevice } from 'components/DeviceDetails/service';
import { useGetIDsFromURL } from 'components/DeviceDetails/helper';

const AddMicroinverters = () => {
    const { Thing_ID } = useGetIDsFromURL();
    const { data: device } = useDevice(Thing_ID);
    const [success, setSuccess] = useState(false);
    const [devicesToValidate, setDevicesToValidate] = useState([]);
    const navigate = useNavigate();

    const onFinish = () => {
        setSuccess(true);
        sessionStorage.setItem('activeStep', 0);
        sessionStorage.setItem('devices', null);
    };

    if (success)
        return (
            <HGSuccessCard
                buttons={[
                    {
                        onClick: () =>
                            navigate(`/sites/${device.Site_ID}`, {
                                replace: true,
                            }),
                        buttonText: 'Go To Site Profile',
                    },
                ]}
            >
                <>
                    Your devices has been successfully added!
                    <br />
                    You can view them by navigating back to site profile.
                </>
            </HGSuccessCard>
        );

    return (
        <HGStepper steps={steps} onFinish={onFinish}>
            {(activeStep, title, content, setActiveStep) => (
                <>
                    <div className="flex mb-5">
                        <div>
                            <p className="text-base">{title}</p>
                            <p className="text-sm">{content}</p>
                        </div>
                    </div>
                    {activeStep === 4 && (
                        <MicroinverterForm
                            register={(devices) => {
                                setActiveStep(5);
                                setDevicesToValidate(devices);
                            }}
                            device={device}
                        />
                    )}
                    {activeStep === 5 && (
                        <ValidateDevices
                            gateway={device}
                            devices={devicesToValidate ?? []}
                        />
                    )}
                </>
            )}
        </HGStepper>
    );
};

export default AddMicroinverters;
